<template>
  <div>
    <el-dialog append-to-body :visible.sync="visible" title="Thêm lô sản phẩm" :close-on-click-modal="false" width="70%">
      <div>
        <el-row :gutter="20" style="padding-bottom: 10px;">
          <el-col :span="7">
            <b class="label-is-required">Mã lô</b>
          </el-col>
          <el-col :span="5">
            <b class="label-is-required">Ngày sản xuất</b>
          </el-col>
          <el-col :span="5">
            <b class="label-is-required">Hạn sử dụng</b>
          </el-col>
          <el-col :span="5">
            <b class="label-is-required">Số lượng</b>
          </el-col>
          <el-col :span="2"></el-col>
        </el-row>
        <div v-for="(expired, index) in expiredSelect" :key="index" style="padding-bottom: 10px;">
          <el-row :gutter="20">
          <el-col :span="7">
            <b-form  @submit.stop.prevent>
              <b-form-input v-model="expired.batchCode" :state="expired.validBatchCode" @input="validateBatchCode(expired)" @blur="checkExistBatchCode(expired)" placeholder="Nhập mã lô" style="height: 40px;"></b-form-input>
              <b-form-invalid-feedback :state="expired.validBatchCode">
                {{ validBatchCodeText }}
              </b-form-invalid-feedback>
            </b-form>
          </el-col>
          <el-form>
            <el-col :span="5">
              <el-form-item :class="valid(expired.validManufactureDate) ? 'is-error' : ''">
                <el-date-picker
                  style="width: 100%;"
                  v-model="expired.manufactureDate"
                  type="date"
                  format="dd-MM-yyyy"
                  @input="validateManufactureDate(expired)"
                  placeholder="Chọn ngày">
                </el-date-picker>
                <div v-if="valid(expired.validManufactureDate) && !expired.validErrorDate" class="el-form-item__error">
                  Không được để trống
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :class="valid(expired.validExpiredDate) ? 'is-error' : ''">
                <el-date-picker
                  style="width: 100%;"
                  v-model="expired.expirationDate"
                  @input="validateExpirationDate(expired)"
                  type="date"
                  format="dd-MM-yyyy"
                  placeholder="Chọn ngày">
                </el-date-picker>
                <div v-if="valid(expired.validExpiredDate) && !expired.validErrorDate" class="el-form-item__error">
                  Không được để trống
                </div>
              </el-form-item>
            </el-col>
          </el-form>
          <el-col :span="5">
            <b-form  @submit.stop.prevent>
              <b-form-input v-model="expired.quantity" :state="expired.validQuantity" @input="validateQuantity(expired)" @keydown="allowNumbersOnly" placeholder="Nhập số lượng" style="height: 40px;"></b-form-input>
              <b-form-invalid-feedback :state="expired.validQuantity">
                không được để trống
              </b-form-invalid-feedback>
            </b-form>
          </el-col>
          <el-col :span="2">
            <div style="text-align: center;">
              <i class="el-icon-close btn-icon color-danger" @click="handleRemove(expired)"/>
            </div>
          </el-col>
          </el-row>
        </div>
      <div @click="addExpried()" class="btn-dashed">
        <i class="el-icon-plus" />
        Thêm số lô
      </div>
      </div>
      <template slot="footer">
        <el-button type="text" @click="visible = false">Thoát</el-button>
        <el-button type="primary" @click="confirmSelect" :loading="btnLoading">Hoàn tất</el-button>
      </template>
    </el-dialog>
    <el-button type="primary" @click="handleModal()" plain>
      Thêm lô sản phẩm
    </el-button>
  </div>
</template>

<script>
import { validExpired, validStorageSwitchCodeLength } from '../../utils/validate'
import { batchCodeSearchDynamic } from '@/api/batchCode'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      validBatchCodeText: '',
      btnLoading: false,
      expired: {
        validBatchCode: null,
        validExpiredDate: null,
        validManufactureDate: null,
        validErrorDate: null,
        validQuantity: null,
        batchCode: '',
        manufactureDate: '',
        expirationDate: '',
        quantity: 1
      },
      expiredSelect: [
        {
          validBatchCode: null,
          validExpiredDate: null,
          validManufactureDate: null,
          validErrorDate: null,
          validQuantity: null,
          batchCode: '',
          manufactureDate: '',
          expirationDate: '',
          quantity: 1
        }
      ],
      visible: false,
      isBatchCodeValid : true
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.expiredSelect = [this.expired]
      }
    }
  },
  methods: {
    valid(val) {
      if (val === false) {
        return true
      } else {
        return false
      }
    },
    //valid batchcode
    checkExistBatchCode(expired) {
      // check in list
      if (!this.validateBatchCode(expired)) {
        return
      } else {
        this.btnLoading = true
        const checkExistInList = this.expiredSelect.filter(batchCode => batchCode.batchCode.toLowerCase() === expired.batchCode.toLowerCase())
        if(checkExistInList.length > 1) {
          expired.validBatchCode = false
          this.validBatchCodeText = 'Mã lô này đã tồn tại'
          this.btnLoading = false
          return
        }
        const checkExist = this.selected.find(batchCode => batchCode.batchCode.toLowerCase() === expired.batchCode.toLowerCase())
        const params = {
          queryString: `{sku}=='''${this.item.sku}''' and {batchCode}=='''${expired.batchCode}'''`,
          limit: 10,
          lastIndex: '',
          sortField: '',
          sortValue: ''
        }
        batchCodeSearchDynamic(params).then(res => {
          if (res.data && res.data.productBatchModelFlat.length > 0 || checkExist) {
            expired.validBatchCode = false
            this.validBatchCodeText = 'Mã lô này đã tồn tại'
          } else {
            expired.validBatchCode = null
            this.validBatchCodeText = ''
          }
          this.btnLoading = false
        })
      }
    },
    validateExpirationDate(item) {
      if (item.expirationDate) {
        item.validExpiredDate = null
        if (item.manufactureDate) {
          item.validManufactureDate = null
        }
      } else {
        item.validExpiredDate = false
      }
    },
    validateManufactureDate (item){
      if (item.manufactureDate) {
        item.validManufactureDate = null
        if (item.expirationDate) {
          item.validExpiredDate = null
        }
      } else {
        item.validManufactureDate = false
      }
    },
    validateBatchCode(item) {
      item.batchCode = item.batchCode.trim()
      if(item.batchCode != "") {
        if (!validExpired(item.batchCode)) {
          item.validBatchCode = false
          this.validBatchCodeText = 'Không được chứa ký tự đặc biệt'
          return false
        } else if (!validStorageSwitchCodeLength(item.batchCode)) {
          item.validBatchCode = false
          this.validBatchCodeText = 'Chiều dài từ 6-25 ký tự'
          return false
        } else {
          item.validBatchCode = null
          this.validBatchCodeText = ''
          return true
        }
      } else {
        item.validBatchCode = false
          this.validBatchCodeText = 'Không được để trống'
          return false
      }
    },
    validateQuantity(item) {
      if (item.quantity) {
        item.validQuantity = null
      } else {
        item.validQuantity = false
      }
    },
    handleModal() {
      this.expiredSelect = [
        {
          validBatchCode: null,
          validExpiredDate: null,
          validManufactureDate: null,
          validQuantity: null,
          batchCode: '',
          manufactureDate: '',
          expirationDate: '',
          quantity: 1
        }
      ]
      this.visible = true
    },
    handleRemove(item) {
      const getIndex = this.expiredSelect.findIndex(expire => expire.batchCode === item.batchCode)
      this.expiredSelect.splice(getIndex, 1)
    },
    validForm() {
      const valid = this.expiredSelect.filter(ex => {
        return !ex.batchCode || !ex.quantity || !ex.expirationDate || !ex.manufactureDate || ex.validBatchCode === false || ex.validQuantity === false || ex.validExpiredDate === false || ex.validManufactureDate === false
      })
      this.expiredSelect.forEach(ex => {
        const check = valid.find(va => va.batchCode === ex.batchCode)
        if (check) {
          if (!check.batchCode) {
            check.validBatchCode = false
            this.validBatchCodeText = 'Không được để trống'
          } if (!check.expirationDate) {
            check.validExpiredDate = false
          } if (!check.manufactureDate) {
            check.validManufactureDate = false
          } if (!check.quantity) {
            check.validQuantity = false
          }
        }
      })
      if(valid.length > 0) {
        return true
      } else {
        return false
      }
    },
    confirmSelect() {
      const validTime = this.expiredSelect.filter(exp => {
        return new Date(exp.manufactureDate).getTime() > new Date(exp.expirationDate).getTime()
      })
      validTime.forEach((exp) => {
        const check = this.expiredSelect.find(valid => valid.batchCode === exp.batchCode)
        if (check) {
          check.validExpiredDate = false
          check.validManufactureDate = false
          check.validErrorDate = true
        } else {
          check.validExpiredDate = true
          check.validManufactureDate = true
          check.validErrorDate = false
        }
      })
      if (validTime.length > 0) {
        this.$message.warning("Ngày sản xuất không được lớn hơn hạn sử dụng")
        return
      }
      this.validBatchCodeToSubmit(this.expiredSelect)
      if(!this.isBatchCodeValid) {
        return
      }
      //validate thông tin lô
      if(this.validForm()) {
        return
      }
      this.$emit('batchs', { batchs: this.expiredSelect, item: this.item})
      this.visible = false
    },
    validBatchCodeToSubmit(expiredSelect) {
      for(let i of expiredSelect) {
        this.validateBatchCode(i)
        if(this.validBatchCodeText == '') {
          this.isBatchCodeValid = true
        } else {
          this.isBatchCodeValid = false
        }
      }
    },
    addExpried() {
      if(this.validForm()) {
        return
      }
      this.expiredSelect.push({
        validBatchCode: null,
        validExpiredDate: null,
        validManufactureDate: null,
        validQuantity: null,
        batchCode: '',
        manufactureDate: '',
        expirationDate: '',
        quantity: 1
      })
    }
  }
}
</script>

<style>

</style>